import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject } from 'rxjs';
import { AssistantResponse } from '@business/entities/assistant';
import { AssistantAPI } from '@business/api/assistant_api';
import { tap } from 'rxjs/operators';

export class AssistantButtonBloc extends BaseBloc {
  constructor(private readonly id: string) {
    super();
  }
  assistant$ = new BehaviorSubject<AssistantResponse | null>(null);

  loading = new LoadingState();

  onInit() {
    return AssistantAPI.fetchAssistant(this.id).pipe(tap(data => this.assistant$.next(data)));
  }
}
